module.exports = __webpack_public_path__ + "img/image-30.d276164e.png";